import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import { SessionStatus } from "@/store/sessions/types";
import { mdsColors } from "@/design-system/foundations";
import styled from "@emotion/styled";

interface SessionStatusIconProps {
  status: SessionStatus;
}

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const SessionStatusIcon: React.FC<SessionStatusIconProps> = ({ status }) => {
  switch (status) {
    case "PROCESSING":
      return <StyledSpinnerIcon kind={MdsIconKind.Spinner} />;
    case "FINISHED":
      return <StyledSuccessIcon kind={MdsIconKind.CheckCircleSolid} />;
    case "ERROR":
      return <StyledErrorIcon kind={MdsIconKind.ExclamationSolid} />;
  }
};

const StyledSpinnerIcon = styled(MdsIcon)`
  width: 32px;
`;

const StyledSuccessIcon = styled(MdsIcon)`
  width: 32px;
  color: ${mdsColors().green.x500};
`;

const StyledErrorIcon = styled(MdsIcon)`
  width: 32px;
  color: ${mdsColors().red.x500};
`;
